import { createSlice } from "@reduxjs/toolkit";

export const meSlice = createSlice({
  name: "me",
  initialState: {
    data: null,
    answersData: null,
    sessionData: null,
    seconds: null,
    questionData: null,
  },
  reducers: {
    setMeData: (state, action) => {
      state.data = action.payload;
    },
    setAnswersData: (state, action) => {
      state.answersData = action.payload;
    },

    setSessionData: (state, action) => {
      state.sessionData = action.payload;
    },

    setSeconds: (state, action) => {
      state.seconds = action.payload;
    },

    setQuestionData: (state, action) => {
      state.questionData = action.payload;
    },
  },
});

export const {
  setMeData,
  setAnswersData,
  setSessionData,
  setSeconds,
  setQuestionData,
} = meSlice.actions;

export default meSlice.reducer;
